var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.500244,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9234 17.3622L23.0334 9.65052C22.437 9.12554 21.6696 8.83594 20.8751 8.83594C20.0805 8.83594 19.3132 9.12554 18.7167 9.65052L9.82674 17.3622C9.55545 17.5946 9.36015 17.9031 9.2661 18.2477C9.17205 18.5924 9.18357 18.9573 9.29917 19.2953C9.41478 19.6333 9.62915 19.9289 9.91455 20.1438C10.2 20.3586 10.5433 20.4829 10.9001 20.5005H11.5417V28.6672C11.5417 29.5954 11.9105 30.4857 12.5669 31.1421C13.2232 31.7984 14.1135 32.1672 15.0417 32.1672H18.5417V25.1672H23.2084V32.1672H26.7084C27.6367 32.1672 28.5269 31.7984 29.1833 31.1421C29.8397 30.4857 30.2084 29.5954 30.2084 28.6672V20.5005H30.8501C31.2069 20.4829 31.5502 20.3586 31.8356 20.1438C32.121 19.9289 32.3354 19.6333 32.451 19.2953C32.5666 18.9573 32.5781 18.5924 32.484 18.2477C32.39 17.9031 32.1947 17.5946 31.9234 17.3622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentIcon);
export default __webpack_public_path__ + "static/media/rent_icon.3531c01a64cfb86cf2283fa194b77edf.svg";
export { ForwardRef as ReactComponent };